import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Modules
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { OpenSchemaDirectivesModule } from '../directives/open-schema-directives.module';
import { ButtonModule } from "primeng/button";
import { SkeletonModule } from "primeng/skeleton";
import { CardModule } from "primeng/card";
import { DataViewModule } from "primeng/dataview";
import { PanelModule } from "primeng/panel";
import { RippleModule } from "primeng/ripple";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TooltipModule } from "primeng/tooltip";
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextareaModule } from 'primeng/inputtextarea';
// Services
import { LayoutRenderService } from './services/layout-render.service';
// Schema Specific
import { Room34SkeletonComponent } from './components/schema/v34/room-skeleton/room-skeleton.component';
import { Room34LayoutComponent } from './components/schema/v34/room-layout/room-layout.component';
import { Room40SkeletonComponent } from './components/schema/v40/room-skeleton/room-skeleton.component';
import { Room40LayoutComponent } from './components/schema/v40/room-layout/room-layout.component';
import { GeneralPropertyDataComponent } from './components/schema/v40/general-property-data/general-property-data.component';
// Common
import { CvLayoutRenderComponent } from './cv-layout-render.component';
import { SectionComponent } from './components/common/section/section.component';
import { RoomLayoutComponent } from './components/common/room-layout/room-layout.component';
import { DynamicComponentComponent } from './components/common/dynamic-component/dynamic-component.component';
import { DynamicHtmlComponent } from './components/common/dynamic-html/dynamic-html.component';
import { TabsSectionComponent } from './components/common/tabs-section/tabs-section.component';
import { PanoramaTourComponent } from './components/common/panorama-tour/panorama-tour.component';
import { ResourceMediaControlComponent } from './components/common/resource-media-control/resource-media-control.component';
import { ReportImageComponent } from './components/common/resource-media-control/report-image/report-image.component';
import { SmartTagFormComponent } from './components/common/smart-tags/smart-tag-form/smart-tag-form.component';
import { PhotoGalleryComponent } from './components/common/photo-gallery/photo-gallery.component';
import { PhotoListSelectedComponent } from './components/common/photo-list-selected/photo-list-selected.component';
import { PhotoListBulkDeleteComponent } from './components/common/photo-list-bulk-delete/photo-list-bulk-delete.component';
import { SingleImageComponent } from './components/common/single-image/single-image.component';
import { InlineRulesComponent } from './components/common/inline-rules/inline-rules.component';
import { AddCommentComponent } from './components/common/inline-rules/components/add-comment/add-comment.component';
import { AddRuleComponent } from './components/common/inline-rules/components/add-rule/add-rule.component';
import { AddStipComponent } from './components/common/inline-rules/components/add-stip/add-stip.component';
import {
	DisplayRuleInformationComponent
} from './components/common/inline-rules/components/display-rule-information/display-rule-information.component';
import { RuleActionsComponent } from './components/common/inline-rules/components/rule-actions/rule-actions.component';
import {
	RuleCommentStipViewItemComponent
} from './components/common/inline-rules/components/rule-comment-stip/rule-comment-stip-view-item.component';
import { RuleItemComponent } from './components/common/inline-rules/components/rule-item/rule-item.component';
import { RuleFeedbackComponent } from './components/common/inline-rules/components/rule-feedback/rule-feedback.component';
import { RuleItemDirectiveDirective } from './components/common/inline-rules/directives/rule-item-directive.directive';
import { MapLocationComponent } from './components/common/map-location/map-location.component';
import { SmartTagsComponent } from './components/common/smart-tags/smart-tags.component';
import { SmartTagItemComponent } from './components/common/smart-tags/smart-tag-item/smart-tag-item.component';
import { SmartTagLocationComponent } from './components/common/smart-tags/smart-tag-location/smart-tag-location.component';
import { TabsSectionButtonComponent } from './components/common/tabs-action-button/tabs-section-button.component';
// Other
import { SMART_TAG_TEMPLATE_DECLARATIONS } from './components/common/smart-tags/smart-tag-form/smart-tags-templates.index';
import { FormFieldComponent } from './components/common/form-field/form-field.component';
import { FormInputFieldComponent } from './components/common/form-field/input-field/input-field.component';
import { FormDisplayFieldComponent } from './components/common/form-field/display-field/display-fields.component';
import { FormFieldSpecialComponent } from './components/common/form-field-special/form-field-special.component';
import {
	PublicRecordModalComponent
} from './components/common/public-record/public-record-modal/public-record-modal.component';
import {
	PublicRecordItemComponent
} from './components/common/public-record/public-record-modal/public-record-item/public-record-item.component';
import {
	PublicRecordDetailComponent
} from './components/common/public-record/public-record-modal/public-record-detail/public-record-detail.component';
import {
	PublicRecordFieldComponent
} from './components/common/public-record/public-record-field/public-record-field.component';
import { FormCustomFieldComponent } from './components/common/form-field/custom-field/custom-field.component';
import {
	PublicRecordSingleComponent
} from './components/common/public-record/public-record-single/public-record-single.component';
import {
	PublicRecordSingleFieldComponent
} from './components/common/public-record/public-record-single-field/public-record-single-field.component';
import { GeneralOrderDataComponent } from './components/schema/v40/general-order-data/general-order-data.component';
import { RotateImageComponent } from './components/common/rotate-image/rotate-image.component';
import { DrawFormsComponent } from "./components/common/draw-forms/draw-forms.component";
import { DynamicFieldsSectionComponent } from './components/common/dynamic-fields-section/dynamic-fields-section.component';

const DECLARATIONS = [
	// Main
	CvLayoutRenderComponent,
	// Common
	SectionComponent,
	RoomLayoutComponent,
	DynamicComponentComponent,
	DynamicHtmlComponent,
	FormFieldComponent,
	FormInputFieldComponent,
	FormDisplayFieldComponent,
	FormFieldSpecialComponent,
	// Resource Media Control INIT //
	ResourceMediaControlComponent,
	// Resource Media Control END //
	// PANORAMA Tour INIT //
	PanoramaTourComponent,
	SmartTagFormComponent,
	ReportImageComponent,
	// PANORAMA Tour END //
	TabsSectionComponent,
	TabsSectionButtonComponent,
	PhotoGalleryComponent,
	SingleImageComponent,
	// Inline Rules INIT //
	InlineRulesComponent,
	AddCommentComponent,
	AddRuleComponent,
	AddStipComponent,
	DisplayRuleInformationComponent,
	RuleActionsComponent,
	RuleCommentStipViewItemComponent,
	RuleItemComponent,
	RuleFeedbackComponent,
	RuleItemDirectiveDirective,
	// Inline Rules END //
	PhotoListSelectedComponent,
	PhotoListBulkDeleteComponent,
	MapLocationComponent,
	SmartTagsComponent,
	SmartTagItemComponent,
	SmartTagLocationComponent,
	// SmartTag Templates
	...SMART_TAG_TEMPLATE_DECLARATIONS,
	// Schema Specific
	Room34SkeletonComponent,
	Room34LayoutComponent,
	Room40SkeletonComponent,
	Room40LayoutComponent,
	GeneralPropertyDataComponent,
	GeneralOrderDataComponent,
	DynamicFieldsSectionComponent,
	//
	PublicRecordModalComponent,
	PublicRecordDetailComponent,
	PublicRecordItemComponent,
	PublicRecordFieldComponent,
	FormCustomFieldComponent,
	PublicRecordSingleComponent,
	PublicRecordSingleFieldComponent,
	DrawFormsComponent,
	RotateImageComponent
];

const EXPORTS = [
  CvLayoutRenderComponent,
  SectionComponent,
  RoomLayoutComponent,
  PhotoGalleryComponent,
];

@NgModule({
	declarations: [
		...DECLARATIONS,
	],
	exports: [ ...EXPORTS ],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		NgbCollapseModule,
		CvComponentLibraryModule,
		OpenSchemaDirectivesModule,
		CvComponentLibraryModule,
		ButtonModule,
		SkeletonModule,
		CardModule,
		DataViewModule,
		PanelModule,
		RippleModule,
		ConfirmDialogModule,
		TooltipModule,
		InputTextareaModule,
    	FieldsetModule
	],
	providers: [ LayoutRenderService ],
	// schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class CvLayoutRenderModule {}
